import { useAuth0 } from "@auth0/auth0-react";
import { DatePickerField } from "_metronic/_partials/controls";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { InputField, LabelField, MyCheckbox, RadioButton, SelectField, TextareaField } from "components";
import AddInstallmentsPayment from "components/Installments/AddInstallmentsPayment";
import { getDateFormat, getDateFormatForDatePicket, maskDate } from "helper/dateFormat";
import { getCurrency } from "helper/numberFormat";
import { useSearch } from "hook";
import FinanceService from "Lib/API/Finance";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import "react-date-range/dist/theme/default.css"; // theme css file
import { default as DatePicker, default as ReactDatePicker } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
import MaskedInput from "react-text-mask";
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import { PriceType } from "../../NewCharge/ChargeType/PercentageFixed";
import InfoTooltip from "../../../../components/InfoTooltip";
const PreviousAmount = ({ types, setShow, show, formik, enableInstallments }) => {
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [discountType, setDiscountType] = useState("%");
  const [taxType, setTaxType] = useState("%");

  const { searchAction } = useSearch({ action: setSearch });
  const [selectfieldColor, setSelectfieldColor] = useState(true);
  const [ledgers, setLedgers] = useState();
  const { getAccessTokenSilently } = useAuth0();
  const [card, setCard] = useState(null);
  const [localFormat, setLocalFormat] = useState(false);
  const [date, setDate] = useState([]);

  const dateMask = maskDate();
  const placeholderFormat = getDateFormat();
  const dateFormat = getDateFormatForDatePicket();
  const currency = getCurrency();
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(dateFormat || "mm/dd/yyyy");

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  const radioList = [
    { name: "Charged date", value: "charge_date" },
    { name: "Due Date", value: "due_date" },
  ];

  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };

  const formatOptionLabel = ({ label, _id }) => {
    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };
  // Get Ledger Subledger List
  const fetchLedgerSubledgerList = async () => {
    const token = await getAccessTokenSilently();
    await FinanceService.getLedgerSubLedgerList(token)
      .then((res) => {
        setLedgers(res?.ledgers);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };
  const getSubledgerList = ledgers?.find(
    (x) => x._id === formik?.values?.Ledger?.id
  );

  useEffect(() => {
    fetchLedgerSubledgerList();
    if (formik?.values.nextpayment === false) {
      formik.setFieldValue(`batch_name`, "");
      formik.setFieldValue(`description`, "");
      formik.setFieldValue(`Ledger`, {
        name: "",
        id: "",
      });
      formik.setFieldValue(`SubLedger`, {
        name: "",
        id: "",
      });
      formik.setFieldValue(`amount`, "");
      formik.setFieldValue("due_date", "");
      formik.setFieldValue(`amount_range.amountFrom`, "");
      formik.setFieldValue(`amount_range.amountTo`, "");
      // formik.setFieldValue(`amount_previous`, "");
      formik.setFieldValue("start_date", "");
      formik.setFieldValue("end_date", "");
      formik.setFieldValue("date_type", "");
      formik.setFieldValue("amount_previous_type", "add_amount");
      formik.setFieldValue(`amount_type`, "%");
      formik.setFieldValue(`tax`, "");
      formik.setFieldValue(`require_notes`, false);
      formik.setFieldValue(`note`, "");
      formik.setFieldValue(`is_splitted`, false);
      formik.setFieldValue(`split_duration`, "");
      formik.setFieldValue(`split_amount`, "");
    }
  }, []);

  const subLegderOptions = getSubledgerList?.sub_ledgers?.map((item) => {
    return {
      label: item?.sub_ledger_name,
      value: item?._id,
      amount: item?.default_amount,
      notes: item?.notes,
    };
  });
  const legderOptions = ledgers?.map((item) => {
    return {
      label: item?.ledger_name,
      value: item?._id,
      amount: item?.default_amount,
      notes: item?.notes,
    };
  });
  const getLedgerOnChange = async (event) => {
    formik.setFieldValue(`Ledger`, {
      id: event?.value,
      name: event?.label,
    });
    formik.setFieldValue(`SubLedger`, "");
    formik.setFieldValue(`amount`, event?.amount);
    formik.setFieldValue(`require_notes`, event?.notes);
  };
  const getSubLedgerOnChange = async (event) => {
    if (!event) {
      formik.setFieldValue(`SubLedger`, {
        id: "",
        name: "",
      });
      const currentLedger = legderOptions.find(
        (item) => item.value === formik.values?.Ledger?.id
      );
      if (currentLedger) {
        formik.setFieldValue(`require_notes`, currentLedger.notes);
      }
      return;
    }
    formik.setFieldValue(`SubLedger`, {
      id: event.value,
      name: event.label,
    });
    formik.setFieldValue(`require_notes`, event?.notes);
    // formik.setFieldValue(`amount`, event?.amount );
  };
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

  useEffect(() => {
    formik.setFieldValue("batch_type", show?.replace(/ /g, "_")?.toLowerCase());
  }, [show]);

  useEffect(() => {
    if (formik.values?.start_date && formik.values?.end_date) {
      setDate([formik.values?.start_date, formik.values?.end_date])
    }
  }, [formik.values])

  const handleSelect = (dates) => {
    const [start, end] = dates;

    console.log(start, end, "datesss")

    if (start === null && end === null) {
      formik.setFieldValue("start_date", null);
      formik.setFieldValue("end_date", null);
      setDate([]);
    }

    if (end < start) {
      setDate([]);
      toastr.error('End Date should be greater than start date.')
      formik.setFieldValue("start_date", null);
      formik.setFieldValue("end_date", null);
    }
    if (end >= start) {
      formik.setFieldValue("start_date", start);
      formik.setFieldValue("end_date", end);
      setDate(dates)
    }
  };

  useEffect(() => {
    if (formik.values.amount_previous_type === "discount" || discountType === "%") {
      if (formik.values?.amount_previous > 100) {
        toastr.info("Validation", "Discount should be less than 100 %")
        formik.setFieldValue(
          `amount_previous`,
          0
        );
      }
    }

  }, [discountType, formik.values.amount_previous_type])

  const handleDiscountValue = (e) => {
    if (discountType === "%" && formik.values.amount_previous_type === "discount") {
      if (e.target.value < 100) {
        formik.setFieldValue(
          `amount_previous`,
          e.target.value.match(regex)[0]
        );
      } else {
        toastr.error("Validation", "Discount should be less than 100 %");
      }
    }
    else {
      formik.setFieldValue(
        `amount_previous`,
        e.target.value.match(regex)[0]
      );
    }
  };

  return (
    <div className="batch-render-comp renderd-comp ">
      <form className="form fv-plugins-bootstrap fv-plugins-framework">
        <div className="col-sm-12 px-sm-18 px-3 pt-10 pb-3 ">
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-8">
              <div className="form-group">
                <InputField
                  mandatory
                  type="text"
                  {...{
                    formik,
                    title: "Bulk Billing",
                    name: `batch_name`,
                    placeholder: "Batch Name",
                    checkValidation: true,
                    value: formik.values?.batch_name,
                  }}
                />
              </div>
            </Col>
            <Col className="col-12 col-md-4 charge-tab">
              <div className="form-group">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <LabelField title="Amount Source" />
                  <InfoTooltip text="Manual = enter amounts yourself. Account = pull amounts from account records. Previous Amount = re-bill past charges matching your filters. File = upload a spreadsheet of amounts." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                </div>
                <div className="charge-type">
                  {types.map((type, idx) => (
                    <span
                      className={
                        type === "Previous Amount" ? "col-sm-3" : "col-sm-3"
                      }
                      style={
                        type === show
                          ? { background: "#2555ef", color: "white" }
                          : {}
                      }
                      key={idx}
                      onClick={() => {
                        setShow(type);
                        formik.setFieldValue("batch_type", type?.toLowerCase());
                      }}
                      {...{
                        formik,
                        name: `batch_type`,
                        value: formik.values?.batch_type,
                      }}
                    >
                      {type}
                    </span>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-12">
              <div className="form-group">
                <InputField
                  // mandatory
                  type="text"
                  {...{
                    formik,
                    title:
                      "Charge Description (will show on the member statement)",
                    name: `description`,
                    placeholder: "",
                    checkValidation: true,
                    value: formik.values?.description,
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-4 charge-tab">
              <div
                className="form-group zIndex999"
              // style={{
              //   zIndex: "99999 !important",
              // }}
              >
                <LabelField mandatory title={"Ledger Account"} />
                <Select
                  mandatory={true}
                  {...{
                    formik,
                    name: `Ledger`,
                    checkValidation: false,
                  }}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={legderOptions}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={getLedgerOnChange}
                  value={{
                    label: formik.values?.Ledger?.name,
                    value: formik.values?.Ledger?.id,
                  }}
                  components={{ DropdownIndicator }}
                />
              </div>
            </Col>
            <Col className="col-12 col-md-4 charge-tab">
              <div className="form-group">
                <LabelField title={"Sub-Ledger Account"} />
                <Select
                  {...{
                    formik,
                    name: `SubLedger`,
                    checkValidation: false,
                  }}
                  // onInputChange={(text) => searchAction(text)}
                  isClearable={formik.values?.SubLedger?.id ?? false}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={subLegderOptions}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={getSubLedgerOnChange}
                  value={{
                    label: formik.values?.SubLedger?.name,
                    value: formik.values?.SubLedger?.id,
                  }}
                  components={{ DropdownIndicator }}
                />
              </div>
            </Col>
            <Col className="col-12 col-md-4">
              <div
                className="form-group"
                style={{
                  zIndex: "11",
                }}
              >
                <SelectField
                  // mandatory={true}
                  {...{
                    formik,
                    title: "Payment / Charge Status",
                    name: "status",
                    items: ["all", "charge", "payment"],
                    value: formik.values.status,
                    placeholder: "Select",
                  }}
                  selectfieldColor={selectfieldColor}
                  onClick={(v) => {
                    formik.setFieldValue("status", v);
                  }}
                />
                {/* <LabelField title={"Payment / Charge Status"} />
                <Select
                  mandatory={true}
                  {...{
                    formik,
                    name: `SubLedger`,
                    checkValidation: false,
                  }}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={legderOptions}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={getLedgerSubLedgerListById}
                  value={{
                    label: formik.values?.SubLedger?.name,
                    value: formik.values?.SubLedger?.id,
                  }}
                  components={{ DropdownIndicator }}
                /> */}
              </div>
            </Col>
          </Row>

          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-4">
              <div className="form-group position-relative ">
                <div className="form-group date-range-radio-btns">
                  <RadioButton
                    title=""
                    list={radioList}
                    card={card ? card.last4 : null}
                    {...{
                      formik,
                      name: "date_type",
                    }}
                  // onClick={dateRange}
                  // boxValue={formik.values?.date_type}
                  />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <LabelField mandatory title={"Date Range"} />
                  <InfoTooltip text="Only past charges dated within this range will be pulled in to re-bill." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                </div>
                <DateRangePicker format={dateFormat}
                  placeholder={`${placeholderFormat} ~ ${placeholderFormat}`}
                  cleanable={true}
                  placement={"bottomEnd"}
                  // onEnter={() => {
                  //   DateRange([null, null]); setDate([])
                  // }}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  style={
                    {
                      display: "inline-block",
                      padding: '0',
                      border: '0',
                      width: "100%",
                      color: 'black'
                    }
                  }
                  size="lg" value={date} onChange={(update) => { handleSelect(update); }} />
                {formik.values?.start_date && formik.values?.end_date && <div style={{
                  position: "absolute",
                  top: "41px",
                  right: "10px",
                  color: "#8080da",
                  cursor: 'pointer',
                  zIndex: "99999999",
                }} onClick={() => { handleSelect([null, null]); setDate([]) }
                }>clear</div>}
                {/* <ReactDatePicker
                  {...{
                    formik,
                    title: "Date Range",
                    name: `date_range`,
                  }}
                  onChange={handleSelect}
                  startDate={formik.values?.start_date ?? ""}
                  endDate={formik.values?.end_date ?? ""}
                  selectsRange
                  placeholderText={"Date Range"}
                  className="date-picker-custom new-batch-daterange"
                /> */}
              </div>
            </Col>
            <Col className="col-12 col-md-4">
              <div className="form-group showDatePicker">
                <LabelField title={"Charge Date"} mandatory />
                <DatePicker
                  // isClearable
                  // disabled={true}
                  showIcon
                  placeholderText={placeholderFormat}
                  dateFormat={dateFormat}
                  selected={
                    formik.values?.charge_date &&
                    new Date(formik.values?.charge_date)
                  }
                  onChange={(e) => {
                    formik.setFieldValue(`charge_date`, e);
                  }}
                />
              </div>
            </Col>
            <Col className="col-12 col-md-4 charge-tab">
              <div className="form-group showDatePicker fixed-position">
                <LabelField title={"Due Date"} mandatory />
                <DatePicker
                  // isClearable
                  showIcon
                  placeholderText={placeholderFormat}
                  dateFormat={dateFormat}
                  minDate={new Date(formik.values?.charge_date)}
                  selected={
                    formik.values?.due_date && new Date(formik.values?.due_date)
                  }
                  onChange={(e) => {
                    formik.setFieldValue(`due_date`, e);
                  }}
                  customInput={
                    <MaskedInput
                      pipe={autoCorrectedDatePipe}
                      mask={dateMask}
                      keepCharPositions={true}
                      guide={true}
                    />
                  }
                />
              </div>
            </Col>
          </Row>
          <Row
            className="mb-4"
            style={{
              alignItems: "center",
            }}
          >
            <Col className="col-12 col-md-2 charge-tab">
              <div className="form-group position-relative">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <LabelField mandatory title="Amount Range From" />
                  <InfoTooltip text="Only past charges with an amount within this range will be pulled in to re-bill." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                </div>
                <InputField
                  mandatory
                  type="number"
                  {...{
                    formik,
                    title: "none",
                    name: `amount_range.amountFrom`,
                    placeholder: "Range from",
                    checkValidation: true,
                    type: "number",
                    placeholderIcon: (
                      <span className="amount-placeholder-icon">{currency}</span>
                    ),
                  }}
                  formStyle={{ marginBottom: 0 }}
                  min="0"
                  // onKeyDown={(e) =>
                  //   exceptThisSymbols.includes(e.key) && e.preventDefault()
                  // }
                  handleChange={(e) => {
                    formik.setFieldValue(
                      `amount_range.amountFrom`,
                      e.target.value.match(regex)[0]
                    );
                  }}
                  value={formik?.values?.amount_range?.amountFrom}
                  onKeyDown={(e) => preventArrows(e)}
                  style={{
                    backgroundColor: "#F3F6F9",
                  }}
                />
              </div>
            </Col>
            <Col className="col-12 col-md-2 charge-tab">
              <div className="form-group position-relative">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <LabelField mandatory title="Amount Range To" />
                  <InfoTooltip text="Only past charges with an amount within this range will be pulled in to re-bill." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                </div>
                <InputField
                  mandatory
                  type="number"
                  {...{
                    formik,
                    title: "none",
                    name: `amount_range.amountTo`,
                    placeholder: "Range to",
                    type: "number",
                    checkValidation: true,
                    placeholderIcon: (
                      <span className="amount-placeholder-icon">{currency}</span>
                    ),
                  }}
                  formStyle={{ marginBottom: 0 }}
                  handleChange={(e) => {
                    formik.setFieldValue(
                      `amount_range.amountTo`,
                      e.target.value.match(regex)[0]
                    );
                  }}
                  min="0"
                  onKeyDown={(e) => preventArrows(e)}
                  // onKeyDown={(e) =>
                  //   exceptThisSymbols.includes(e.key) && e.preventDefault()
                  // }
                  value={formik?.values?.amount_range?.amountTo}
                  style={{
                    backgroundColor: "#F3F6F9",
                  }}
                />
              </div>
            </Col>
            <Col className="col-3 col-sm-3 px-0 mb-5">
              <InputField
                type="number"
                {...{
                  formik,
                  title: "Tax Deductible",
                  name: `tax`,
                  placeholderIcon: (
                    <span className="amount-placeholder-icon">
                      {/* {"$"} */}
                      {formik.values?.tax_type === "%" ? "%" : currency}
                    </span>
                  ),
                  placeholder: "Tax",
                  value: formik.values?.tax,

                  checkValidation: true,
                }}
                onKeyDown={(e) => preventArrows(e)}
                min="0"
                // onKeyDown={(e) =>
                //   exceptThisSymbols.includes(e.key) && e.preventDefault()
                // }
                handleChange={(e) => {
                  formik.setFieldValue(
                    `tax`,
                    e.target.value.match(regex)[0]
                  );
                }}
                style={{
                  backgroundColor: "#F3F6F9",
                  border: "none",
                }}
              />
            </Col>
            <Col className="col-1 col-sm-1 p-0 m-0 price-type">
              <PriceType
                value={formik.values?.tax_type}
                handleClick={setTaxType}
                setFieldValue={formik.setFieldValue}
                type="tax_type"
                name="tax_type"
              />
            </Col>


          </Row>
          <Row className="form-row sm-12 mb-4 justify-content-start">


            <Col className="col-3 col-sm-3 px-0 mb-5">
              <InputField
                type="number"
                {...{
                  formik,
                  title: "Add Amount / Discount ",
                  name: `amount_previous`,
                  placeholderIcon: (
                    <span className="add-amount placeholder-icon">
                      {formik.values?.amount_type === "%" ? "%" : currency}
                    </span>
                  ),
                  placeholder: formik.values.amount_previous_type === "discount" ? "Discount" : "Amount",
                  value: formik.values?.amount_previous ?? formik.values?.discount,
                  checkValidation: true,
                }}
                // handleChange={(e) => {
                //   formik.setFieldValue(
                //     `amount_previous`,
                //     e.target.value.match(regex)[0]
                //   );
                // }}
                handleChange={(e) => {
                  handleDiscountValue(e);
                }}
                onKeyDown={(e) => preventArrows(e)}
                style={{
                  backgroundColor: "#F3F6F9",
                  border: "none",
                }}
                min="0"
              // onKeyDown={(e) =>
              //   exceptThisSymbols.includes(e.key) && e.preventDefault()
              // }
              />
            </Col>
            <Col className="col-1 col-sm-1 p-0 m-0 price-type">
              <PriceType
                value={formik.values?.amount_type ?? formik.values?.discount_type}
                handleClick={setDiscountType}
                setFieldValue={formik.setFieldValue}
                type="amount_type"
                name="previous-amount"
              />
            </Col>
            <Col className="col-3 col-sm-3 px-0 mb-5">
              <div>
                <div className="d-flex align-items-center amount-add-btns">
                  <LabelField
                    className={
                      formik.values?.amount_previous_type === "add_amount"
                        ? "paid-by"
                        : "mr-5"
                    }
                    title={"Add Amount"}
                    onClick={() => {
                      formik.setFieldValue("amount_previous_type", "add_amount");
                    }}
                  />
                  <LabelField
                    className={
                      formik.values?.amount_previous_type !== "add_amount"
                        ? "paid-by"
                        : ""
                    }
                    title={"Discount"}
                    onClick={() => {
                      formik.setFieldValue("amount_previous_type", "discount");
                    }}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Col className="col mb-10 px-0">
            <div
              className="d-flex align-items-center"
              style={{
                gap: "2rem",
              }}
            >
              <div
                className=""
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <MyCheckbox
                  name={`is_splitted`}
                  split_amount
                  title="Split"
                  handlechange={(event) => {
                    formik.setFieldValue(
                      `is_splitted`,
                      event.target.checked
                    );
                    formik.setFieldValue(`isInstallmentTransaction`, false);
                    formik.setFieldValue(`installmentDetailsTransaction`, undefined);
                  }}
                  value={formik.values?.is_splitted}
                  checked={formik.values?.is_splitted}
                />
                <InfoTooltip text={<>Break this batch <b>charge</b> into multiple payments spread over time, instead of billing the full amount at once.</>} style={{ marginLeft: '6px', marginBottom: '8px' }} />
              </div>
              {enableInstallments && (
                <div
                  className=""
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <MyCheckbox
                    name={`isInstallmentTransaction`}
                    split_amount
                    title="Allow Installments"
                    handlechange={(event) => {
                      formik.setFieldValue(
                        `isInstallmentTransaction`,
                        event.target.checked
                      );
                      formik.setFieldValue(`is_splitted`, false);
                    }}
                    value={formik.values?.isInstallmentTransaction}
                    checked={formik.values?.isInstallmentTransaction}
                  />
                  <InfoTooltip text="Let the payer spread this batch charge across multiple scheduled installments instead of paying it all at once." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                </div>
              )}
            </div>
            {(formik.values?.isInstallmentTransaction && enableInstallments) && (
              <AddInstallmentsPayment
                formik={formik}
                formikKey="installmentDetailsTransaction"
              />
            )}
            {formik.values?.is_splitted && (
              <Row>
                <div className="col-sm-5 col-md-4">
                  <SelectField
                    {...{
                      formik,
                      name: `split_duration`,
                      items: ["day", "week", "month", "quarter", "year"],
                      placeholder: "Select",
                      value: formik.values?.split_duration ? (
                        <span style={{ color: "black" }}>
                          {formik.values?.split_duration}
                        </span>
                      ) : (
                        "Select"
                      ),
                    }}
                    onClick={(data) =>
                      formik.setFieldValue(
                        `split_duration`,
                        data
                      )
                    }
                  />
                </div>
                {formik.values?.split_duration ? (
                  <div className="col-sm-3">
                    <InputField
                      type="number"
                      {...{
                        formik,
                        title: "",
                        name: `number_of_split`,
                        placeholder: "0",
                        value: formik.values?.number_of_split,
                        checkValidation: true,
                      }}
                      onKeyDown={(e) => preventArrows(e)}
                      handleChange={(e) => {
                        const newValue = parseInt(e.target.value);
                        formik.setFieldValue(
                          `number_of_split`,
                          newValue
                        );
                      }}
                    />
                    <div className="placeholder-div">
                      <p>{formik.values?.split_amount}</p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </Row>
            )}
          </Col>
          <Row className="form-row sm-12 mb-0">
            <Col className="col-sm-12 px-0">
              <TextareaField
                mandatory={formik?.values?.require_notes ? true : false}
                {...{
                  formik,
                  title: "Add Note",
                  name: `note`,
                  placeholder: "Note text",
                  style: { resize: "none" },
                  checkValidation: true,
                  onChange: (value) => {
                    formik.setFieldValue(`note`, value);
                  },
                }}
                defaultValue={
                  formik?.values?.note
                }
              />
            </Col>
          </Row>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <MyCheckbox
              {...{
                formik,
                title: "Add Note",
                name: `comment_checkbox`,
              }}
              // disabled={formik.values.type === "edit-charge" ? true : false}
              title="Comment on invoice"
              handleSubmit
              handlechange={(event) => {
                formik.setFieldValue(
                  `comment_checkbox`,
                  event.target.checked
                );
              }}
              checked={formik?.values?.comment_checkbox}
            />
            <InfoTooltip text="Show the note above on the invoice sent to the payer, instead of keeping it internal only." style={{ marginLeft: '6px', marginBottom: '8px' }} />
          </div>
        </div>
      </form>
    </div>
  );
};

export default PreviousAmount;
